import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { Outlet } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import 'moment/locale/ar'
import { useLangUrl } from '../../utilities/useLangUrl';

export default function AdminSetting() {
    const navigate = useNavigate();
    const langUrl = useLangUrl()
    useEffect(() => {
        if (!Cookies.get('adminToken')) {
            // if (!localStorage.getItem("adminToken")) {
            navigate("/admin/adminLogin")
        }
    }, [navigate, langUrl])
    return (
        <Outlet />
    )
}